// extracted by mini-css-extract-plugin
export default {"imageWrapper":"QK-z","hovered":"RK-z","hoverImage":"SK-z","mainImage":"TK-z","imageNoBackground":"UK-z","fullSizeImage":"VK-z"};